import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CountryService } from '../shared/countries/country.service';
import {
    AdminsProxy,
    AuditTrailsProxy,
    ChairOrdersProxy,
    ChairsProxy,
    GroupManagersProxy,
    GroupProxy,
    InvoiceProxy,
    OrdersProxy,
    PracticeInvitationProxy,
    PracticeProxy,
    PurchaseOrdersProxy,
    StocksProxy,
    TestsProxy,
    UsersProxy,
} from '../shared/proxies';
import { ExactProxy } from '../shared/proxies/exact/exact.proxy';
import { ExperimentsProxy } from '../shared/proxies/experiments/experiments.proxy';
import { MessagesProxy } from '../shared/proxies/messages/messages.proxy';
import { OrdersBaseProxy } from '../shared/proxies/orders-base/orders-base.proxy';
import { ValidationFactories } from '../shared/validation/validation-factories';
import { AuthInterceptor } from './auth/auth.interceptor';
import { ErrorInterceptor } from './error-handling/error-interceptor';
import { EncodeHttpParamsInterceptor } from './http/encode-httpParams.interceptor';
import { VersionInterceptor } from './version/version.interceptor';

@NgModule({
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: VersionInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: EncodeHttpParamsInterceptor,
            multi: true,
        },
        GroupManagersProxy,
        GroupProxy,
        PracticeProxy,
        PracticeInvitationProxy,
        OrdersProxy,
        OrdersBaseProxy,
        InvoiceProxy,
        TestsProxy,
        PurchaseOrdersProxy,
        MessagesProxy,
        UsersProxy,
        AuditTrailsProxy,
        StocksProxy,
        AdminsProxy,
        ChairsProxy,
        ChairOrdersProxy,
        ExperimentsProxy,
        ExactProxy,
        ValidationFactories,
        CountryService,
    ],
    imports: [CommonModule, HttpClientModule],
})
export class CoreModule {
    constructor(
        @Optional()
        @SkipSelf()
        parentModule: CoreModule
    ) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
        }
    }
}
